export default "__VITE_ASSET__BU$rVPxQ__"